export const GLOBAL_SYMBOL = 'WEL'
export const NATIVE_TOKEN_PRECISION = 6
